import React from 'react';
import './App.css';
import ImgName from './components/ImgName';
import AboutMe from './components/AboutMe';
import Experience from './components/Experience';
import Project from './components/Projects';
import Awards from './components/Awards';
import Footer from './components/Footer';


function App() {
  const appStyle = {
    background: '#141215',
    backgroundSize: "400% 400%",
    height: '100vh', // Full height of the viewport
    WebkitAnimation: "Gradient 3s ease infinite",
    MozAnimation: "Gradient 3s ease infinite",
    animation: "Gradient 3s ease infinite",
  };

  return (
    <div className="App" style={appStyle}>
      <ImgName />
      <AboutMe />
      <Experience />
      <Project />
      <Awards />
      <Footer />
    </div>
  );
}

export default App;
